var map = {
	"./10quad105a110.png": 207343,
	"./10quad105a130.png": 446041,
	"./10quad105a145.png": 181397,
	"./10quad105a150.png": 822035,
	"./10quad105a65.png": 732038,
	"./10quad110a75.png": 159175,
	"./10quad115a115.png": 64225,
	"./10quad135a30.png": 380699,
	"./10quad150a140.png": 419430,
	"./10quad150a140_1.png": 526610,
	"./10quad150a25.png": 56752,
	"./10quad150a50.png": 532244,
	"./10quad35a150.png": 825525,
	"./10quad40a55.png": 736681,
	"./10quad50a20.png": 723120,
	"./10quad50a75.png": 126794,
	"./10quad60a70.png": 204464,
	"./10quad60a75.png": 133181,
	"./10quad65a45.png": 415519,
	"./10quad65a90.png": 526529,
	"./10quad65a95.png": 203612,
	"./10quad90a125.png": 27878,
	"./10quad90a140.png": 865169,
	"./10quad90a90.png": 367129,
	"./10quad90a90_1.png": 454585,
	"./15quad105a115.png": 568473,
	"./15quad105a45.png": 143189,
	"./15quad115a135.png": 462380,
	"./15quad115a135_1.png": 339228,
	"./15quad115a20.png": 824047,
	"./15quad115a50.png": 368674,
	"./15quad125a125.png": 419634,
	"./15quad125a150.png": 409970,
	"./15quad130a70.png": 626173,
	"./15quad140a40.png": 616615,
	"./15quad145a140.png": 151991,
	"./15quad145a15.png": 615534,
	"./15quad145a55.png": 928098,
	"./15quad15a95.png": 446992,
	"./15quad20a130.png": 803224,
	"./15quad30a25.png": 233932,
	"./15quad35a125.png": 545804,
	"./15quad35a40.png": 570848,
	"./15quad50a55.png": 409223,
	"./15quad50a70.png": 341280,
	"./15quad60a110.png": 895014,
	"./15quad75a60.png": 300054,
	"./15quad80a50.png": 713443,
	"./15quad85a125.png": 51769,
	"./15quad95a135.png": 713337,
	"./20quad105a65.png": 130079,
	"./20quad110a45.png": 693159,
	"./20quad115a20.png": 278303,
	"./20quad120a15.png": 55183,
	"./20quad125a70.png": 153583,
	"./20quad145a120.png": 861765,
	"./20quad15a130.png": 151308,
	"./20quad25a115.png": 139698,
	"./20quad25a50.png": 485674,
	"./20quad35a25.png": 851787,
	"./20quad35a70.png": 33045,
	"./20quad45a100.png": 456626,
	"./20quad50a145.png": 357861,
	"./20quad70a40.png": 555023,
	"./20quad75a10.png": 957723,
	"./20quad80a40.png": 89448,
	"./20quad85a125.png": 941673,
	"./20quad90a70.png": 966884,
	"./20quad95a90.png": 742437,
	"./25quad105a35.png": 415793,
	"./25quad110a60.png": 448469,
	"./25quad115a95.png": 958002,
	"./25quad130a100.png": 728544,
	"./25quad135a35.png": 56742,
	"./25quad145a110.png": 179227,
	"./25quad145a90.png": 90898,
	"./25quad15a115.png": 435970,
	"./25quad35a105.png": 407259,
	"./25quad35a55.png": 823005,
	"./25quad35a80.png": 29343,
	"./25quad40a75.png": 849811,
	"./25quad50a45.png": 24859,
	"./25quad60a20.png": 943495,
	"./25quad75a125.png": 126773,
	"./25quad75a125_1.png": 458925,
	"./270deg.png": 897191,
	"./3QuartTurn.png": 44075,
	"./3QuartTurnAC.png": 554523,
	"./AboveSquare.png": 710394,
	"./Acute-01.png": 310538,
	"./Acute-010.png": 116880,
	"./Acute-02.png": 467969,
	"./Acute-03.png": 730488,
	"./Acute-04.png": 852631,
	"./Acute-05.png": 153134,
	"./Acute-06.png": 380965,
	"./Acute-07.png": 145052,
	"./Acute-08.png": 850091,
	"./Acute-09.png": 475938,
	"./Acute-10.png": 161256,
	"./Acute-11.png": 59121,
	"./Acute-12.png": 128954,
	"./Acute-13.png": 446531,
	"./Acute-14.png": 516364,
	"./Acute-15.png": 885461,
	"./Acute-16.png": 718110,
	"./Acute-17.png": 436423,
	"./Acute-18.png": 992192,
	"./Acute-19.png": 447017,
	"./Acute-20.png": 183149,
	"./Acute.png": 359948,
	"./Acute1.png": 68031,
	"./Arrow.png": 806167,
	"./Arrowsaboveeachother.png": 467562,
	"./Arrowspointingaway.png": 192888,
	"./Arrowspointingtowards.png": 541828,
	"./Asset 210.png": 114733,
	"./BehindSquare.png": 885063,
	"./BelowSquare.png": 31370,
	"./Circdia10.png": 462942,
	"./Circdia20.png": 775055,
	"./Circdia50.png": 371266,
	"./Circle.png": 463790,
	"./Circlecirc.png": 757455,
	"./Circledia.png": 475002,
	"./Circlerad.png": 345797,
	"./Circlerad15.png": 133847,
	"./Circrad10.png": 445409,
	"./Circrad15.png": 647228,
	"./Circrad30.png": 363223,
	"./Cube.png": 756397,
	"./Cubeplan.png": 927800,
	"./Cubesquareface.png": 464155,
	"./Cuboid.png": 446880,
	"./Cuboidplan.png": 262601,
	"./Cylinder.png": 418468,
	"./Cylindercircleface.png": 494451,
	"./Cylinderplan.png": 987085,
	"./Grid-1,-1.png": 735740,
	"./Grid-1,-2.png": 536375,
	"./Grid-1,-3.png": 393358,
	"./Grid-1,-4.png": 229473,
	"./Grid-1,-5.png": 744856,
	"./Grid-1,1.png": 384317,
	"./Grid-1,2.png": 343078,
	"./Grid-1,3.png": 382095,
	"./Grid-1,4.png": 939248,
	"./Grid-1,5.png": 536153,
	"./Grid-2,-1.png": 798081,
	"./Grid-2,-2.png": 283850,
	"./Grid-2,-3.png": 922707,
	"./Grid-2,-4.png": 567836,
	"./Grid-2,-5.png": 650725,
	"./Grid-2,1.png": 192606,
	"./Grid-2,2.png": 359957,
	"./Grid-2,3.png": 990860,
	"./Grid-2,4.png": 921027,
	"./Grid-2,5.png": 603450,
	"./Grid-3,-1.png": 607170,
	"./Grid-3,-2.png": 155353,
	"./Grid-3,-3.png": 558448,
	"./Grid-3,-4.png": 1295,
	"./Grid-3,-5.png": 962278,
	"./Grid-3,1.png": 404719,
	"./Grid-3,2.png": 230228,
	"./Grid-3,3.png": 663261,
	"./Grid-3,4.png": 959010,
	"./Grid-3,5.png": 180139,
	"./Grid-4,-1.png": 729839,
	"./Grid-4,-2.png": 708372,
	"./Grid-4,-3.png": 929501,
	"./Grid-4,-4.png": 767778,
	"./Grid-4,-5.png": 658283,
	"./Grid-4,1.png": 474304,
	"./Grid-4,2.png": 855515,
	"./Grid-4,3.png": 533970,
	"./Grid-4,4.png": 863949,
	"./Grid-4,5.png": 200708,
	"./Grid-5,-1.png": 428680,
	"./Grid-5,-2.png": 765539,
	"./Grid-5,-3.png": 1434,
	"./Grid-5,-4.png": 341557,
	"./Grid-5,-5.png": 589292,
	"./Grid-5,1.png": 487865,
	"./Grid-5,2.png": 631778,
	"./Grid-5,3.png": 852907,
	"./Grid-5,4.png": 902996,
	"./Grid-5,5.png": 336029,
	"./Grid1,-1.png": 473291,
	"./Grid1,-2.png": 719792,
	"./Grid1,-3.png": 800345,
	"./Grid1,-4.png": 123622,
	"./Grid1,-5.png": 646287,
	"./Grid1,1.png": 148412,
	"./Grid1,2.png": 949047,
	"./Grid1,3.png": 806030,
	"./Grid1,4.png": 642145,
	"./Grid1,5.png": 673880,
	"./Grid1,6.png": 848371,
	"./Grid1,7.png": 693162,
	"./Grid1,8.png": 927229,
	"./Grid1,9.png": 706100,
	"./Grid2,-1.png": 266810,
	"./Grid2,-2.png": 443057,
	"./Grid2,-3.png": 994664,
	"./Grid2,-4.png": 574279,
	"./Grid2,-5.png": 398494,
	"./Grid2,1.png": 422119,
	"./Grid2,2.png": 37292,
	"./Grid2,3.png": 120181,
	"./Grid2,4.png": 262234,
	"./Grid2,5.png": 967459,
	"./Grid2,6.png": 630600,
	"./Grid2,7.png": 870545,
	"./Grid2,8.png": 359062,
	"./Grid2,9.png": 137151,
	"./Grid3,-1.png": 157273,
	"./Grid3,-2.png": 92738,
	"./Grid3,-3.png": 830219,
	"./Grid3,-4.png": 267956,
	"./Grid3,-5.png": 5437,
	"./Grid3,1.png": 539766,
	"./Grid3,2.png": 971533,
	"./Grid3,3.png": 791940,
	"./Grid3,4.png": 446747,
	"./Grid3,5.png": 641554,
	"./Grid3,6.png": 189737,
	"./Grid3,7.png": 65536,
	"./Grid3,8.png": 509767,
	"./Grid3,9.png": 333982,
	"./Grid4,-1.png": 800800,
	"./Grid4,-2.png": 155835,
	"./Grid4,-3.png": 890482,
	"./Grid4,-4.png": 272045,
	"./Grid4,-5.png": 745892,
	"./Grid4,1.png": 464849,
	"./Grid4,2.png": 856538,
	"./Grid4,3.png": 561763,
	"./Grid4,4.png": 631596,
	"./Grid4,5.png": 714485,
	"./Grid4,6.png": 628734,
	"./Grid4,7.png": 500071,
	"./Grid4,8.png": 872800,
	"./Grid4,9.png": 327625,
	"./Grid5,-1.png": 264455,
	"./Grid5,-2.png": 344396,
	"./Grid5,-3.png": 713493,
	"./Grid5,-4.png": 956986,
	"./Grid5,-5.png": 274563,
	"./Grid5,1.png": 49816,
	"./Grid5,2.png": 224307,
	"./Grid5,3.png": 373546,
	"./Grid5,4.png": 358213,
	"./Grid5,5.png": 40700,
	"./Grid5,6.png": 629431,
	"./Grid5,7.png": 155790,
	"./Grid5,8.png": 971353,
	"./Grid5,9.png": 255600,
	"./Grid6,1.png": 338627,
	"./Grid6,2.png": 476648,
	"./Grid6,3.png": 925041,
	"./Grid6,4.png": 880478,
	"./Grid6,5.png": 56263,
	"./Grid6,6.png": 805580,
	"./Grid6,7.png": 717205,
	"./Grid6,8.png": 188050,
	"./Grid6,9.png": 993243,
	"./Grid7,1.png": 709042,
	"./Grid7,2.png": 523657,
	"./Grid7,3.png": 645536,
	"./Grid7,4.png": 596863,
	"./Grid7,5.png": 699926,
	"./Grid7,6.png": 513901,
	"./Grid7,7.png": 260004,
	"./Grid7,8.png": 3875,
	"./Grid7,9.png": 756122,
	"./Grid8,1.png": 813581,
	"./Grid8,2.png": 381814,
	"./Grid8,3.png": 435615,
	"./Grid8,4.png": 907584,
	"./Grid8,5.png": 31785,
	"./Grid8,6.png": 483602,
	"./Grid8,7.png": 805147,
	"./Grid8,8.png": 101132,
	"./Grid8,9.png": 12757,
	"./Grid9,1.png": 132500,
	"./Grid9,2.png": 153967,
	"./Grid9,3.png": 572422,
	"./Grid9,4.png": 174841,
	"./Grid9,5.png": 168592,
	"./Grid9,6.png": 82411,
	"./Grid9,7.png": 191906,
	"./Grid9,8.png": 613285,
	"./Grid9,9.png": 861020,
	"./Gridsquare.png": 519535,
	"./Gridsquare22.png": 577259,
	"./Gridsquare42.png": 391713,
	"./Gridsquare50.png": 822408,
	"./Gridsquaremirror.png": 837072,
	"./Gridsquaremirror11.png": 639536,
	"./Gridsquaremirror20.png": 760516,
	"./Gridsquaremirror22.png": 991990,
	"./Gridsquaremirror23.png": 45791,
	"./Horizontalline.png": 402572,
	"./InfrontSquare.png": 658063,
	"./LeftSquare.png": 195588,
	"./NETCone.png": 349288,
	"./NETCyl.png": 226289,
	"./NETSqupyr.png": 744391,
	"./NETcube.png": 401590,
	"./NETcuboid.png": 781635,
	"./NEThexprism.png": 125791,
	"./NETtrianprism.png": 724156,
	"./NETtripyr.png": 87825,
	"./NSymCircle.png": 703029,
	"./NSymSquare.png": 347072,
	"./NSymrect.png": 550083,
	"./NSymtriangle.png": 335181,
	"./Obtuse-01.png": 222446,
	"./Obtuse-02.png": 450277,
	"./Obtuse-03.png": 698012,
	"./Obtuse-04.png": 595411,
	"./Obtuse-05.png": 379850,
	"./Obtuse-06.png": 20929,
	"./Obtuse-07.png": 799800,
	"./Obtuse-08.png": 474607,
	"./Obtuse-09.png": 409414,
	"./Obtuse-10.png": 585676,
	"./Obtuse-11.png": 954773,
	"./Obtuse-12.png": 787422,
	"./Obtuse-13.png": 505735,
	"./Obtuse-14.png": 714216,
	"./Obtuse-15.png": 128433,
	"./Obtuse-16.png": 198266,
	"./Obtuse-17.png": 999491,
	"./Obtuse-18.png": 319447,
	"./Obtuse-19.png": 298125,
	"./Obtuse.png": 128816,
	"./Obtuse1.png": 727675,
	"./Parallellines.png": 674154,
	"./Perplines.png": 52184,
	"./Pyramid.png": 756464,
	"./Pyramid2.png": 464224,
	"./Pyramidplan.png": 521209,
	"./Pyramidsquareface.png": 361138,
	"./Pyramidtriangleface.png": 387195,
	"./Quarterturn.png": 409997,
	"./QuarterturnAC.png": 338761,
	"./Rectangle.png": 622727,
	"./Rectangle2.png": 755701,
	"./Rectangle3.png": 519788,
	"./Reflex-01.png": 790718,
	"./Reflex-02.png": 876469,
	"./Reflex-03.png": 124204,
	"./Reflex-04.png": 300451,
	"./Reflex-05.png": 536346,
	"./Reflex-06.png": 957457,
	"./Reflex-07.png": 963592,
	"./Reflex-08.png": 893439,
	"./Reflex-09.png": 480150,
	"./Reflex-10.png": 871708,
	"./Reflex-11.png": 623973,
	"./Reflex-12.png": 396142,
	"./Reflex-13.png": 95639,
	"./Reflex-14.png": 973496,
	"./Reflex-15.png": 194625,
	"./Reflex-16.png": 37194,
	"./Reflex-17.png": 769107,
	"./Reflex-18.png": 143188,
	"./Reflex-19.png": 364317,
	"./Reflex1.png": 975403,
	"./Right-01.png": 486092,
	"./Right-010.png": 340822,
	"./Right-02.png": 736775,
	"./Right-03.png": 560990,
	"./Right-04.png": 605553,
	"./Right-05.png": 157160,
	"./Right-06.png": 535491,
	"./Right-07.png": 429306,
	"./Right-08.png": 198541,
	"./Right-09.png": 535300,
	"./Right-10.png": 532266,
	"./Right-11.png": 383027,
	"./Right-12.png": 208536,
	"./Right-13.png": 481249,
	"./Right-14.png": 798158,
	"./Right-15.png": 788151,
	"./Right-16.png": 683068,
	"./Right-17.png": 516933,
	"./Right-18.png": 616066,
	"./Right-19.png": 379723,
	"./Right-20.png": 23867,
	"./RightAngle1.png": 366952,
	"./RightSquare.png": 498559,
	"./Sphere.png": 186565,
	"./Square.png": 952555,
	"./SquareOutCircle.png": 483299,
	"./SquareTri.png": 607984,
	"./SquareTriCir.png": 22948,
	"./SquareinCircle.png": 691054,
	"./SymCircle.png": 533985,
	"./SymSquare.png": 170892,
	"./Symtriangle.png": 434193,
	"./Triangle.png": 885698,
	"./TriangleA.png": 829233,
	"./TriangleB.png": 415418,
	"./TriangleRA.png": 511817,
	"./TriangleRA2.png": 868863,
	"./Triangleangles.png": 783906,
	"./Triangleangles2.png": 712490,
	"./Triangprismplan.png": 496789,
	"./TriangularPrismPlan.png": 126811,
	"./Verticalline.png": 465978,
	"./WholeTurn.png": 855792,
	"./WholeTurnAC.png": 529176,
	"./blade.png": 311906,
	"./circlecentre.png": 360279,
	"./circlecircum.png": 627997,
	"./circlediameter.png": 757779,
	"./circleradius.png": 170948,
	"./circletrianglerectangle.png": 478563,
	"./circletrianglesquare.png": 711087,
	"./clockhand12.png": 445720,
	"./compass.png": 563684,
	"./compassE.png": 836211,
	"./compassN.png": 986352,
	"./compassS.png": 398485,
	"./compassW.png": 572145,
	"./dial.png": 591127,
	"./firstquadgrid.png": 270231,
	"./firstquadgrid13.png": 646983,
	"./firstquadgrid15.png": 999409,
	"./firstquadgrid23.png": 926122,
	"./firstquadgrid25.png": 593276,
	"./firstquadgrid32.png": 726420,
	"./firstquadgrid35.png": 676331,
	"./firstquadgrid42.png": 273257,
	"./firstquadgrid43.png": 302080,
	"./firstquadgrid51.png": 927705,
	"./firstquadgrid52.png": 379522,
	"./firstquadgrid55.png": 998250,
	"./fullquadgrid-1-1.png": 190952,
	"./fullquadgrid-11.png": 805401,
	"./fullquadgrid-2-2.png": 58624,
	"./fullquadgrid-2-4.png": 413622,
	"./fullquadgrid-3-3.png": 649684,
	"./fullquadgrid-34.png": 231726,
	"./fullquadgrid-4-1.png": 833777,
	"./fullquadgrid-4-2.png": 903610,
	"./fullquadgrid-4-4.png": 291020,
	"./fullquadgrid-42.png": 495397,
	"./fullquadgrid-44.png": 283731,
	"./fullquadgrid11.png": 79150,
	"./fullquadgrid2-2.png": 773145,
	"./fullquadgrid24.png": 898402,
	"./fullquadgrid3-2.png": 195020,
	"./fullquadgrid31.png": 622296,
	"./fullquadgrid33.png": 641578,
	"./fullquadgrid4-1.png": 191400,
	"./fullquadgrid4-4.png": 915605,
	"./fullquadgrid43.png": 832459,
	"./fullquadgrid44.png": 540468,
	"./grid.png": 543370,
	"./grid2squares.png": 113228,
	"./grid2squares15.png": 9378,
	"./grid2squares25.png": 481891,
	"./grid2squares43.png": 143235,
	"./grid2squares52.png": 495297,
	"./grid2squares54.png": 523159,
	"./grid2squares55.png": 577582,
	"./halfturn.png": 274712,
	"./halfturnAC.png": 572608,
	"./irregpoly1.png": 927678,
	"./irregpoly2.png": 529781,
	"./irregpoly3.png": 777516,
	"./isosTriangle.png": 204868,
	"./isossidetriangle10c.png": 807207,
	"./isossidetriangle14a.png": 590681,
	"./isossidetriangle14a_1.png": 455737,
	"./isossidetriangle14b.png": 42498,
	"./isossidetriangle14b_1.png": 637014,
	"./isossidetriangle16b.png": 556344,
	"./isossidetriangle18b.png": 761606,
	"./isossidetriangle20a.png": 923334,
	"./isossidetriangle24a.png": 2378,
	"./isossidetriangle28b.png": 183349,
	"./isossidetriangle30b.png": 239324,
	"./isossidetriangle34c.png": 844041,
	"./isossidetriangle34c_1.png": 893993,
	"./isossidetriangle38b.png": 112500,
	"./isossidetriangle42b.png": 70221,
	"./isossidetriangle44b.png": 777039,
	"./isossidetriangle44c.png": 491942,
	"./isossidetriangle58a.png": 331241,
	"./isossidetriangle60b.png": 914649,
	"./isossidetriangle62a.png": 550492,
	"./isossidetriangle62c.png": 74926,
	"./isossidetriangle64a.png": 57982,
	"./isossidetriangle64b.png": 660085,
	"./isossidetriangle64b_1.png": 170989,
	"./isossidetriangle64b_2.png": 780310,
	"./isossidetriangle66b.png": 956803,
	"./isossidetriangle66c.png": 155578,
	"./isossidetriangle68a.png": 198794,
	"./isossidetriangle68b.png": 229377,
	"./isossidetriangle6b.png": 159537,
	"./isossidetriangle70b.png": 504152,
	"./isossidetriangle70c.png": 776865,
	"./isossidetriangle72c.png": 962411,
	"./isossidetriangle74a.png": 358671,
	"./isossidetriangle74a_1.png": 380387,
	"./isossidetriangle74b.png": 623412,
	"./isossidetriangle78b.png": 585632,
	"./isossidetriangle80a.png": 722508,
	"./isossidetriangle80c.png": 440606,
	"./isossidetriangle80c_1.png": 782874,
	"./isossidetriangle8c.png": 711146,
	"./isostoptriangle10b.png": 689144,
	"./isostoptriangle14b.png": 522196,
	"./isostoptriangle16b.png": 552318,
	"./isostoptriangle18b.png": 202688,
	"./isostoptriangle20a.png": 969792,
	"./isostoptriangle22a.png": 942998,
	"./isostoptriangle22c.png": 291172,
	"./isostoptriangle28a.png": 440120,
	"./isostoptriangle28b.png": 235731,
	"./isostoptriangle28c.png": 20170,
	"./isostoptriangle36c.png": 136693,
	"./isostoptriangle38a.png": 267017,
	"./isostoptriangle38b.png": 936050,
	"./isostoptriangle38b_1.png": 190662,
	"./isostoptriangle42a.png": 655696,
	"./isostoptriangle42a_1.png": 988360,
	"./isostoptriangle42c.png": 322210,
	"./isostoptriangle44b.png": 357793,
	"./isostoptriangle44c.png": 85080,
	"./isostoptriangle46a.png": 358564,
	"./isostoptriangle48b.png": 930453,
	"./isostoptriangle50a.png": 879863,
	"./isostoptriangle50c.png": 608645,
	"./isostoptriangle54b.png": 149248,
	"./isostoptriangle56a.png": 196673,
	"./isostoptriangle62b.png": 292609,
	"./isostoptriangle62c.png": 71480,
	"./isostoptriangle66a.png": 56134,
	"./isostoptriangle66a_1.png": 144946,
	"./isostoptriangle66c.png": 404308,
	"./isostoptriangle66c_1.png": 230004,
	"./isostoptriangle6a.png": 56704,
	"./isostoptriangle6a_1.png": 413816,
	"./isostoptriangle72b.png": 245300,
	"./isostoptriangle74b.png": 254370,
	"./isostoptriangle74c.png": 144875,
	"./isostoptriangle78c.png": 261519,
	"./isostoptriangle80b.png": 634625,
	"./isostoptriangle8b.png": 274793,
	"./isostoptriangle8b_1.png": 955209,
	"./line104a.png": 452978,
	"./line11c.png": 20807,
	"./line124a.png": 702648,
	"./line139a.png": 467630,
	"./line13b.png": 506996,
	"./line148b.png": 512857,
	"./line152b.png": 765930,
	"./line15b.png": 108514,
	"./line166b.png": 868217,
	"./line173a.png": 802316,
	"./line29a.png": 505422,
	"./line33b.png": 606146,
	"./line35c.png": 139997,
	"./line36b.png": 517925,
	"./line42b.png": 862346,
	"./line55a.png": 792077,
	"./line55b.png": 360310,
	"./line56b.png": 485675,
	"./line57a.png": 514599,
	"./line61c.png": 487616,
	"./line63c.png": 837246,
	"./line68c.png": 828275,
	"./line73c.png": 408247,
	"./line78b.png": 737227,
	"./line94b.png": 458497,
	"./line99b.png": 989006,
	"./misstriangle15a.png": 729007,
	"./misstriangle15a50.png": 511624,
	"./misstriangle15a65.png": 235648,
	"./misstriangle15a85.png": 700058,
	"./misstriangle20a.png": 413471,
	"./misstriangle20a50.png": 926520,
	"./misstriangle25a.png": 491260,
	"./misstriangle25a75.png": 215888,
	"./misstriangle30a.png": 834574,
	"./misstriangle30a15.png": 763212,
	"./misstriangle30a20.png": 418076,
	"./misstriangle30a40.png": 920026,
	"./misstriangle30a45.png": 79911,
	"./misstriangle30a55.png": 889432,
	"./misstriangle30a60.png": 185344,
	"./misstriangle35a.png": 939001,
	"./misstriangle35a65.png": 873182,
	"./misstriangle35a70.png": 4376,
	"./misstriangle40a.png": 77113,
	"./misstriangle45a.png": 972686,
	"./misstriangle45a30.png": 596071,
	"./misstriangle50a.png": 286248,
	"./misstriangle50a35.png": 956088,
	"./misstriangle50a80.png": 476392,
	"./misstriangle55a.png": 993571,
	"./misstriangle55a85.png": 959350,
	"./misstriangle60a.png": 886619,
	"./misstriangle60a15.png": 769789,
	"./misstriangle60a45.png": 244746,
	"./misstriangle60a65.png": 621372,
	"./misstriangle65a.png": 542496,
	"./misstriangle65a85.png": 855133,
	"./misstriangle70a.png": 248618,
	"./misstriangle70a80.png": 312330,
	"./misstriangle75a.png": 123277,
	"./misstriangle80a.png": 201653,
	"./misstriangle80a55.png": 362267,
	"./misstriangle80a75.png": 826337,
	"./misstriangle85a.png": 527026,
	"./misstriangle85a15.png": 134424,
	"./misstriangle85a20.png": 734784,
	"./misstriangle85a40.png": 191638,
	"./misstriangle85a45.png": 466107,
	"./misstriangle85a50.png": 974641,
	"./misstriangle85a85.png": 945743,
	"./oppangle100b.png": 440903,
	"./oppangle101a.png": 755923,
	"./oppangle103b.png": 708674,
	"./oppangle104b.png": 110259,
	"./oppangle104b_1.png": 453599,
	"./oppangle105b.png": 809492,
	"./oppangle107b.png": 882366,
	"./oppangle108a.png": 190004,
	"./oppangle108c.png": 343718,
	"./oppangle10a.png": 455320,
	"./oppangle10b.png": 629811,
	"./oppangle115a.png": 453978,
	"./oppangle115a_1.png": 677502,
	"./oppangle115a_2.png": 279605,
	"./oppangle116a.png": 352123,
	"./oppangle116b.png": 573792,
	"./oppangle118b.png": 592798,
	"./oppangle11c.png": 957725,
	"./oppangle124a.png": 816146,
	"./oppangle126b.png": 672999,
	"./oppangle127b.png": 973912,
	"./oppangle129a.png": 93565,
	"./oppangle129b.png": 26150,
	"./oppangle130c.png": 953741,
	"./oppangle130c_1.png": 637461,
	"./oppangle137a.png": 756834,
	"./oppangle139b.png": 884075,
	"./oppangle13a.png": 368821,
	"./oppangle140a.png": 279400,
	"./oppangle140a_1.png": 901136,
	"./oppangle140b.png": 81027,
	"./oppangle146b.png": 522521,
	"./oppangle14c.png": 649694,
	"./oppangle150b.png": 349154,
	"./oppangle152b.png": 112024,
	"./oppangle155a.png": 227662,
	"./oppangle157c.png": 360906,
	"./oppangle15b.png": 903544,
	"./oppangle160a.png": 937322,
	"./oppangle160a_1.png": 956942,
	"./oppangle163c.png": 204953,
	"./oppangle164b.png": 393405,
	"./oppangle164c.png": 172276,
	"./oppangle164c_1.png": 188372,
	"./oppangle166c.png": 697698,
	"./oppangle168a.png": 510882,
	"./oppangle169b.png": 435250,
	"./oppangle169c.png": 700603,
	"./oppangle20b.png": 228528,
	"./oppangle20b_1.png": 719400,
	"./oppangle24c.png": 689717,
	"./oppangle26a.png": 117581,
	"./oppangle26b.png": 685814,
	"./oppangle27a.png": 548966,
	"./oppangle33a.png": 91451,
	"./oppangle40c.png": 40831,
	"./oppangle43b.png": 797899,
	"./oppangle49c.png": 447660,
	"./oppangle50c.png": 365006,
	"./oppangle60a.png": 51407,
	"./oppangle60b.png": 832500,
	"./oppangle67c.png": 675008,
	"./oppangle70b.png": 869173,
	"./oppangle72a.png": 880616,
	"./oppangle76a.png": 759580,
	"./oppangle78c.png": 50388,
	"./oppangle79c.png": 379455,
	"./oppangle80a.png": 207169,
	"./oppangle83a.png": 436468,
	"./oppangle85b.png": 525261,
	"./oppangle86a.png": 906487,
	"./oppangle87b.png": 237371,
	"./oppangle87b_1.png": 620983,
	"./oppangle87b_2.png": 32252,
	"./oppangle88a.png": 799769,
	"./oppangle95a.png": 55819,
	"./oppangle97c.png": 848323,
	"./oppangle99b.png": 833412,
	"./point100a157.png": 330923,
	"./point102b145.png": 928321,
	"./point104a127.png": 469862,
	"./point107c112.png": 997583,
	"./point108b107.png": 232029,
	"./point115c57.png": 331148,
	"./point117b73.png": 87221,
	"./point117c170.png": 330328,
	"./point126b167.png": 76027,
	"./point132b28.png": 685232,
	"./point132c60.png": 849561,
	"./point138b131.png": 945611,
	"./point143c157.png": 778854,
	"./point144a12.png": 980361,
	"./point147c129.png": 501914,
	"./point147c18.png": 725588,
	"./point14b90.png": 327296,
	"./point150a134.png": 429209,
	"./point159a136.png": 61622,
	"./point160c93.png": 425404,
	"./point164c151.png": 586309,
	"./point168c98.png": 582807,
	"./point19a29.png": 818020,
	"./point30c144.png": 693623,
	"./point33b165.png": 868712,
	"./point33b165_1.png": 279248,
	"./point41c109.png": 157994,
	"./point48a122.png": 42124,
	"./point57a150.png": 910827,
	"./point57c84.png": 513959,
	"./point58c165.png": 592902,
	"./point59a35.png": 248475,
	"./point61c45.png": 177887,
	"./point69b166.png": 531814,
	"./point73b108.png": 795747,
	"./point73b130.png": 453866,
	"./point87c104.png": 626993,
	"./point92b19.png": 484743,
	"./point97b107.png": 719554,
	"./point97c38.png": 984166,
	"./quad1.png": 271378,
	"./raTriangle.png": 285581,
	"./rect12x20.png": 203859,
	"./rect15x50.png": 943579,
	"./rect20x40.png": 799444,
	"./rect25x50.png": 549040,
	"./rect5x10.png": 70748,
	"./rectlongside.png": 435735,
	"./rectlongside150.png": 225029,
	"./rectlongside20.png": 303713,
	"./rectlongside270.png": 967052,
	"./rectlongside45.png": 416310,
	"./rectlongside8.png": 377231,
	"./rectshortside.png": 803749,
	"./rectshortside15.png": 184951,
	"./rectshortside2.png": 459539,
	"./rectshortside5.png": 104668,
	"./rectshortside7.png": 933550,
	"./rectshortside75.png": 74705,
	"./right11a.png": 762551,
	"./right20a.png": 72371,
	"./right21b.png": 596967,
	"./right23a.png": 223762,
	"./right24c.png": 238269,
	"./right27c.png": 382076,
	"./right32a.png": 427868,
	"./right33a.png": 951779,
	"./right35a.png": 509061,
	"./right41a.png": 746798,
	"./right49a.png": 828278,
	"./right51a.png": 724107,
	"./right51b.png": 758704,
	"./right5c.png": 153138,
	"./right60b.png": 116700,
	"./right64a.png": 621627,
	"./right66a.png": 940641,
	"./right69b.png": 461907,
	"./right70a.png": 800710,
	"./right77a.png": 605483,
	"./right7a.png": 20086,
	"./right85a.png": 153678,
	"./right8a.png": 802131,
	"./symrect.png": 510319,
	"./triangle15a44.png": 488971,
	"./triangle16a68.png": 704436,
	"./triangle22a70.png": 804240,
	"./triangle22a73.png": 691883,
	"./triangle23b39.png": 769885,
	"./triangle23c20.png": 948490,
	"./triangle28c75.png": 580317,
	"./triangle30b70.png": 359024,
	"./triangle31b82.png": 191512,
	"./triangle35b68.png": 449872,
	"./triangle36b81.png": 683706,
	"./triangle37b65.png": 974284,
	"./triangle38a45.png": 41083,
	"./triangle40a18.png": 408122,
	"./triangle41a8.png": 419484,
	"./triangle49c80.png": 644988,
	"./triangle52c27.png": 18909,
	"./triangle52c65.png": 432419,
	"./triangle53b38.png": 565683,
	"./triangle54a21.png": 907715,
	"./triangle54a21_1.png": 583151,
	"./triangle54c13.png": 249078,
	"./triangle55a14.png": 270576,
	"./triangle59a48.png": 838911,
	"./triangle59b26.png": 750068,
	"./triangle59b46.png": 898226,
	"./triangle59b70.png": 78137,
	"./triangle59c67.png": 263436,
	"./triangle5b85.png": 319254,
	"./triangle61b69.png": 610168,
	"./triangle63b21.png": 935858,
	"./triangle63b32.png": 649186,
	"./triangle63b49.png": 552720,
	"./triangle65b65.png": 683832,
	"./triangle66c54.png": 85976,
	"./triangle67a37.png": 546388,
	"./triangle68a15.png": 843537,
	"./triangle68c72.png": 470878,
	"./triangle70a51.png": 586828,
	"./triangle71b20.png": 334780,
	"./triangle71c39.png": 979543,
	"./triangle72b83.png": 785088,
	"./triangle74a19.png": 350244,
	"./triangle75c45.png": 695466,
	"./triangle76c45.png": 582695,
	"./triangle77a66.png": 137023,
	"./triangle79b46.png": 851924,
	"./triangle81c37.png": 372138,
	"./triangle81c82.png": 566042,
	"./triangle83a61.png": 67187,
	"./triangle85a41.png": 302795,
	"./triangle8b56.png": 321625,
	"./triangle90a18.png": 502443,
	"./triangle90a33.png": 928470,
	"./triangle90a53.png": 389268,
	"./triangle90a55.png": 118050,
	"./triangle90a57.png": 967888,
	"./triangle90a72.png": 52107,
	"./triangle90a73.png": 288450,
	"./triangle90a84.png": 783332,
	"./triangle90b10.png": 926944,
	"./triangle90b16.png": 464982,
	"./triangle90b16_1.png": 869826,
	"./triangle90b25.png": 958328,
	"./triangle90b29.png": 128020,
	"./triangle90b31.png": 158019,
	"./triangle90b54.png": 417432,
	"./triangle90b84.png": 720535,
	"./triangle90c11.png": 166540,
	"./triangle90c11_1.png": 52796,
	"./triangle90c41.png": 69903,
	"./triangle90c48.png": 950926,
	"./triangle90c52.png": 196179,
	"./triangle90c78.png": 700303,
	"./triangle90c84.png": 973238,
	"./trianglea0.png": 361861,
	"./trianglea1.png": 832444,
	"./trianglea3.png": 490062,
	"./trianglea4.png": 326177,
	"./trianglea5.png": 841560,
	"./trianglea8.png": 611261,
	"./windmill.png": 551750,
	"./windmillblueattop.png": 873312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 294492;